// @ts-nocheck
import type * as Types from '@lingoda/monolith-graphql/src/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type IntervalFragment = {
    readonly __typename?: 'DateInterval';
    readonly years: number;
    readonly months: number;
    readonly weeks: number;
    readonly days: number;
    readonly hours: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly microseconds: number;
    readonly forHumans: string;
};

export const IntervalFragmentDoc = gql`
    fragment interval on DateInterval {
        years
        months
        weeks
        days
        hours
        minutes
        seconds
        microseconds
        forHumans
    }
` as unknown as DocumentNode<IntervalFragment, unknown>;
